import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PdfDownloadButton } from '../../../../components/atoms/Base';
import PurchaseOrderFile from '../../report/PurchaseOrderFile';
import { opportunityDetailActions } from '../../../../redux/opportunity/opportunity/opportunityDetailState';

export default function PurchaseOrderDownloadButton(props) {
  const { orderId } = props;

  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [isReadyDownload, setReadyDownload] = React.useState(false);
  const dbPdfData = useSelector((state) => state.opportunityDetailStore.pdfDatas);
  const [pdfData, setPdfData] = React.useState({ header: {} });
  const [isClickedOnDownload, setClickedOnDownload] = React.useState(false);

  useEffect(() => {
    if (dbPdfData && isClickedOnDownload) {
      setPdfData(dbPdfData);
      setClickedOnDownload(false);
      setLoading(false);
      setReadyDownload(true);
    }
  }, [dbPdfData]);

  const onComfimationDownload = () => {
    dispatch(opportunityDetailActions.getPdfData({ orderId }));
    setPdfData({ header: {} });
    setLoading(true);
    setReadyDownload(false);
    setClickedOnDownload(true);
  };

  return (
    <PdfDownloadButton
      title="発注書ダウンロード"
      file={<PurchaseOrderFile data={pdfData} />}
      pdfData={pdfData}
      isReadyDownload={isReadyDownload}
      onClick={onComfimationDownload}
      loading={loading}
      onClose={() => { setReadyDownload(false); }}
    />
  );
}
